import { Save } from '@mui/icons-material'
import { IconButton, TextField } from '@mui/material'
import { useEffect, useState } from 'react'

const notesRowStyle = {
  display: 'flex',
  width: '95%',
  marginTop: 5,
}

const notesStyle = {
  width: '100%',
  margin: '5px 0px',
}

export const NoteField = ({ initialNote, onSaveNote, isViewOnly }) => {
  const [text, setCurrentNote] = useState(initialNote ? initialNote.text : '')

  useEffect(() => {
    setCurrentNote(initialNote ? initialNote.text : '')
  }, [initialNote])

  const onNoteChanged = (text) => {
    setCurrentNote(text)
  }

  const handleSaveNote = () => {
    onSaveNote(text)
  }

  return (
    <div style={notesRowStyle}>
      <TextField
        style={notesStyle}
        placeholder="Intentions, main priority, or notes go here!"
        size="small"
        value={text}
        disabled={isViewOnly}
        onChange={(e) => onNoteChanged(e.target.value)}
      />
      <IconButton onClick={handleSaveNote} disabled={isViewOnly}>
        <Save />
      </IconButton>
    </div>
  )
}
